import {Injectable} from '@angular/core';
import {IAppState} from '../models/IAppState';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {
  public static setSavedState(state: IAppState, localStorageKey: string) {
    try {
      localStorage.setItem(localStorageKey, JSON.stringify(state));
    } catch (error) {
      console.log(error);
    }

    return state;
  }

  public static getSavedState(state: IAppState, localStorageKey: string): any {
    const savedState = localStorage.getItem(localStorageKey);
    let savedStateJson: IAppState | any = {};

    try {
      savedStateJson = JSON.parse(savedState);
    } catch (e) {
      localStorage.removeItem(localStorageKey);
    }
    const res: IAppState = Object.assign({}, state, savedStateJson);
    res.isAuthorised = !!res.isAuthorised;

    return res;
  }
}
